import Card from '@mui/material/Card';
import { makeStyles } from '@material-ui/styles';
import axios from 'src/utils/axios';
import { useLocation } from 'react-router';
import { useParams, useHistory } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import {
  Backdrop,
  CircularProgress,
  Snackbar,
  IconButton,
  Grid,
  Typography,
  Button,
  Box,
  Divider
} from '@material-ui/core';
import Alert from 'src/components/Alert';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { DataGrid } from '@material-ui/data-grid';
import moment from 'moment';

const useStyles = makeStyles(theme => ({
  root: {
    fontFamily: 'Segoe UI',
    width: '100%',
    height: '100%'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#FFA500'
  }
}));

function SarisDynamicUnitDetail() {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const { UnitCode, UserUnitCode, UnitDesc } = useParams();
  const [unitCodeSelectedDelete, setUnitCodeSelectedDelete] = useState([]);
  const [unitCodeSelectedInsert, setUnitCodeSelectedInsert] = useState([]);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const [loading, setLoading] = React.useState(false);
  const [selectedRowsExclude, setSelectedRowsExclude] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });

  const columns = [
    { field: 'kul_birim_kodu', headerName: 'Birim', width: 150 },
    { field: 'aciklama', headerName: 'Açıklama', width: 250 },
    { field: 'servis_tipi', headerName: 'Servis Tipi', width: 250 },
    { field: 'adsoyad', headerName: 'Ekleyen Kullanıcı', width: 250 },
    {
      field: 'tarih',
      headerName: 'Eklenme Tarihi',
      width: 150,
      renderCell: params => {
        // params.value tarihin string formatını veya Date objesini içerir
        return moment(params.value).format('DD/MM/YYYY HH:mm:ss');
      }
    }
  ];

  const columnsOther = [
    { field: 'kul_birim_kodu', headerName: 'Birim', width: 150 },
    { field: 'aciklama', headerName: 'Açıklama', width: 250 },
    { field: 'servis_tipi', headerName: 'Servis Tipi', width: 250 },
    { field: 'adsoyad', headerName: 'Ekleyen Kullanıcı', width: 250 },
    {
      field: 'tarih',
      headerName: 'Eklenme Tarihi',
      width: 200,
      renderCell: params => {
        // params.value tarihin string formatını veya Date objesini içerir
        return moment(params.value).format('DD/MM/YYYY HH:mm:ss');
      }
    }
  ];

  useEffect(() => {
    handleGetSarisDynamicUnitSelectedDeleteData();
    handleGetSarisDynamicUnitSelecetedInsertData();
  }, []);

  const handleGetSarisDynamicUnitSelectedDeleteData = () => {
    setLoading(true);
    axios
      .get(`SetSarisDynamicUnitTypeSelectedDelete/${UnitCode}`)
      .then(response => {
        setLoading(false);
        var data = response.data;
        setUnitCodeSelectedDelete(data);
      })
      .catch(error => {
        setLoading(false);
        return;
      });
  };

  const handleGetSarisDynamicUnitSelecetedInsertData = () => {
    setLoading(true);
    axios
      .get(`SetSarisDynamicUnitTypeSelectedInsert/${UnitCode}`)
      .then(response => {
        setLoading(false);
        var data = response.data;
        setUnitCodeSelectedInsert(data);
      })
      .catch(error => {
        setLoading(false);
        return;
      });
  };

  const handleGetSarisDynamiNewUnitCodeInclude = selectedIncludeUnitList => {
    setLoading(true);
    axios
      .get(
        `SetSarisDynamicIncludeNewUnit/${UnitCode}/${selectedIncludeUnitList}`
      )
      .then(response => {
        setLoading(false);
        var data = response.data;
        if (data.ErrorCode == '1000') {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('error');
          setUyari(true);
          handleGetSarisDynamicUnitSelectedDeleteData();
          handleGetSarisDynamicUnitSelecetedInsertData();
          handleClearSelection();
          return;
        } else {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('success');
          setUyari(true);
          handleGetSarisDynamicUnitSelectedDeleteData();
          handleGetSarisDynamicUnitSelecetedInsertData();
          handleClearSelection();
          return;
        }
      })
      .catch(error => {
        setLoading(false);
        return;
      });
  };

  const handleGetSarisUnitCodeExclude = selectedUnitCodeList => {
    setLoading(true);
    axios
      .get(`SetSarisDynamicUnitExclude/${UnitCode}/${selectedUnitCodeList}`)
      .then(response => {
        setLoading(false);
        var data = response.data;
        if (data.ErrorCode == '1000') {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('error');
          setUyari(true);
          handleGetSarisDynamicUnitSelectedDeleteData();
          handleGetSarisDynamicUnitSelecetedInsertData();
          handleClearSelection();
          return;
        } else {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('success');
          setUyari(true);
          handleGetSarisDynamicUnitSelectedDeleteData();
          handleGetSarisDynamicUnitSelecetedInsertData();
          handleClearSelection();
          return;
        }
      })
      .catch(error => {
        setLoading(false);
        return;
      });
  };

  const handleGoBack = () => {
    const fullPath = location.pathname;
    const basePath = fullPath
      .split('/')
      .slice(0, 2)
      .join('/');
    // Detay sayfasından dönüldüğünü belirtmek için previousPath'i güncelliyoruz.
    localStorage.setItem('previousPath', basePath || '/');
    history.goBack(); // Geri gitmek için useHistory hook'unu kullanıyoruz.
  };
  const handleClearSelection = () => {
    setSelectedRows([]);
    setSelectedRowsExclude([]);
  };

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  return (
    <>
      <Snackbar
        open={uyari}
        autoHideDuration={5000}
        onClose={uyariKapat}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={uyariKapat}
          variant={uyariTip}
          message={responseMessage}
        />
      </Snackbar>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Card sx={{ width: '100%', height: '100%', position: 'relative' }}>
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            sx={{ position: 'absolute', top: 16, left: 16 }}
          >
            <IconButton
              style={{ color: '#FF9800' }}
              onClick={() => {
                handleGoBack();
              }}
            >
              <ArrowBackIcon />
            </IconButton>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <Typography
              gutterBottom
              variant="h4"
              style={{
                display: 'flex',
                justifyContent: 'center',
                fontWeight: 'bold',
                marginTop: '1rem',
                color: '#FF9800'
              }}
            >
              {UserUnitCode}-{UnitDesc}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Divider variant="middle" />
          </Grid>
          <Grid
            container
            alignItems="center"
            justifyContent="center"
            style={{ height: '100%', padding: 16 }}
          >
            <Grid item xs={12} sm={10} md={8} lg={6}>
              <div style={{ height: 350, width: '100%' }}>
                <DataGrid
                  rows={unitCodeSelectedDelete}
                  columns={columns}
                  getRowId={rows => rows.alt_birim_kodu}
                  checkboxSelection
                  onSelectionModelChange={newSelection =>
                    setSelectedRowsExclude(newSelection)
                  }
                  selectionModel={selectedRowsExclude}
                />
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{ display: 'flex', justifyContent: 'center', marginTop: 2 }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  width: '100%'
                }}
              >
                <Button
                  sx={{ minWidth: 150, minHeight: 150 }}
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    handleGetSarisUnitCodeExclude(selectedRowsExclude);
                  }}
                >
                  Seçili Olanı Sil
                </Button>
              </Box>
            </Grid>
          </Grid>
          <Grid
            container
            alignItems="center"
            justifyContent="center"
            style={{ height: '100%', padding: 16 }}
          >
            <Grid item xs={12} sm={10} md={8} lg={6}>
              <div style={{ height: 700, width: '100%' }}>
                <DataGrid
                  rows={unitCodeSelectedInsert}
                  columns={columnsOther}
                  getRowId={rows => rows.alt_birim_kodu}
                  checkboxSelection
                  onSelectionModelChange={newSelection =>
                    setSelectedRows(newSelection)
                  }
                  selectionModel={selectedRows}
                />
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{ display: 'flex', justifyContent: 'center', marginTop: 2 }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  width: '100%'
                }}
              >
                <Button
                  sx={{ minWidth: 150, minHeight: 150 }}
                  variant="contained"
                  color="secondary"
                  onClick={() => {
                    handleGetSarisDynamiNewUnitCodeInclude(selectedRows);
                  }}
                >
                  Seçili Olanı Ekle
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </>
  );
}

export default SarisDynamicUnitDetail;
